import { z } from 'zod';

import { BooleanParamSchema } from '../../common/boolean-param/boolean-param';
import { makeListQuery } from '../../common/list-query/list-query';
import { ProductAudienceSchema } from '../product-audience/product-audience';
import { ProductKeysParamSchema } from '../product-keys-param/product-keys-param';
import { ProductKindSchema } from '../product-kind/product-kind';

/**
 * The catalogue's filters (N7) — "which plans do we sell, to whom?".
 *
 * `search` matches across **both** locales, because an operator looking for a
 * plan types whichever name they think in and the catalogue is small enough that
 * a cross-locale scan costs nothing (the `searchAcrossLocales` path N5 provides).
 *
 * No price filter: the price is not on the row — it is a gender-scoped setting
 * resolved per caller (U15), so "cheaper than X" has no single answer here.
 *
 * `keys` is resolve-by-**key** for the admin `ServerSelect`, and it is what lets
 * a saved `product_key` render as a plan's name anywhere outside this catalogue:
 * an order row, a discount rule's scope, a `billing.directPrices` entry. Every
 * one of those holds the **key**, never the id — which is why an `ids` filter
 * would not have answered them (see `ProductKeysParamSchema`).
 *
 * `kind` is how a picker that can only use a PLAN — the comp grant — asks for
 * plans alone (D9b2); the desk that records payments leaves it unsaid.
 */
export const SubscriptionProductsListQuerySchema = makeListQuery({
  kind: ProductKindSchema.optional(),
  audience: ProductAudienceSchema.optional(),
  isActive: BooleanParamSchema.optional(),
  search: z.string().trim().min(1).optional(),
  keys: ProductKeysParamSchema.optional(),
});

export type SubscriptionProductsListQuery = z.infer<typeof SubscriptionProductsListQuerySchema>;
